<template>
  <v-container class="py-0 text-center gradient-text">
 
  </v-container>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>x
.gradient-text {
  background: linear-gradient(to right, #8e2de2, #ff6a00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
